// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-w_jinbi[data-v-d8ddbb34],.pyb-text[data-v-d8ddbb34]{display:inline-block}.icon-w_jinbi[data-v-d8ddbb34]{color:#fbc94f}.big-icon[data-v-d8ddbb34]{font-size:35px}.small-icon[data-v-d8ddbb34]{font-size:28px}.big-text[data-v-d8ddbb34]{font-size:28px}.big-text[data-v-d8ddbb34],.small-text[data-v-d8ddbb34]{display:inline-block;color:#2cb774;font-weight:700}.small-text[data-v-d8ddbb34]{font-size:20px;padding:0 4px}", ""]);
// Exports
module.exports = exports;
